import React from "react";
import UserDialogContent from "./userDialogContent";
import { CloseIcon } from "@icarius-icons";
import { withStyles } from "@material-ui/core/styles";
import { getLocalizedString } from "@icarius-localization/strings";
import { Dialog, DialogTitle } from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";

const StyledDialog = withStyles({
  paper: {
    minHeight: "90vh",
    maxHeight: "90vh",
  },
})(Dialog);

const UserDialog = (props) => {

  const {
    open,
    employee,
    isLoading,
    hideLoading,
    handleGenerate,
    handleClose,
  } = props;

  return (
    <StyledDialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={open}
      scroll={"paper"}
      maxWidth={"md"}
      fullWidth={true}
      >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {getLocalizedString("collabData")}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <UserDialogContent
        isLoading={isLoading}
        employee={employee}
        hideLoading={hideLoading}
        handleGenerate={handleGenerate}
      />
    </StyledDialog>
  );
}
export default UserDialog;
